import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Redirect } from 'react-router';
const createRoutes = () => [
    {
        path: '/offers',
        exact: true,
        component: ({ location }) => _jsx(Redirect, { to: `/${location.search}` }),
    },
    {
        path: '/offers/:offer_id(\\d+)',
        component: require('./pages/Offer').default,
    },
];
export default createRoutes;
